import React, { ReactElement } from "react";
import RateCheckedIcon from "@/assets/summary/rate_checked.svg?react";
import Popover from "@/component/Popover";
import { playRateList } from "@/constants/playrate";
import fridayReporter from "@/utils/friday";

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  playRate: string;
  children: ReactElement;
  setPlayRate: (playRate: string) => void;
  mode: "light" | "dark"
}

const PlayRateModal: React.FC<IProps> = ({ visible, setVisible, playRate, children, setPlayRate, mode = "light" }) => {
  const handleChangeRate = (rate: string) => {
    setPlayRate(rate);
    setVisible(false);
    fridayReporter.pushData({
      eventCode: 'SummaryPage_Play_Speed',
      payload: {
        speed_number: `${rate}x`
      }
    })
  };

  const content = playRateList.map((item) => (
    <div
      key={item.value}
      className={`w-30 h-8 flex items-center justify-between ${mode === "light" ? "text-mx-secondary" : "text-white"} text-3.5 line-height-5.5 px-2 py-1.25 cursor-pointer`}
      onClick={() => handleChangeRate(item.value)}
    >
      {item.text}
      {item.value === playRate && <RateCheckedIcon className="w-4 h-4" />}
    </div>
  ));

  return (
    <Popover visible={visible} setVisible={setVisible} content={content} placement="topRight" mode={mode}>
      {children}
    </Popover>
  );
};

export default PlayRateModal;
